module.exports = __webpack_public_path__ + "img/qrcode_gzh.21b82919.jpg";